import { buildMetaDescription } from "./productMetaDescription";

interface CmsSeoBlock {
	title?: string;
	og_title?: string;
	description?: string;
	og_description?: string;
	og_image?: string;
}

interface CmsStoryContent {
	Title?: string;
	SEO?: CmsSeoBlock | null;
}

export interface CmsSeoFields {
	title?: string;
	ogTitle?: string;
	description?: string;
	ogDescription?: string;
	ogImage?: string;
}

/**
 * Meta fields for a CMS page. Editors leave the SEO block empty on many
 * pages (FAQ, terms, privacy), so the visible heading stands in for the
 * title and the first text block for the description. Storyblok returns ""
 * for empty fields, hence `||` throughout and `undefined` for "unset".
 */
export const buildCmsSeoFields = (
	content: CmsStoryContent,
	firstTextHtml: string
): CmsSeoFields => {
	const seo = content.SEO || {};
	const title = seo.title || content.Title || undefined;
	const description =
		buildMetaDescription(seo.description, firstTextHtml) || undefined;

	return {
		title,
		ogTitle: seo.og_title || title,
		description,
		ogDescription: seo.og_description || description,
		ogImage: seo.og_image || undefined
	};
};
